"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useToggle = exports.FavoritesButton = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactMintl = require("@godaddy/react-mintl");
var _uxUtils = require("@site/ux-utils");
var _button = _interopRequireDefault(require("@ux/button"));
var _classnames = _interopRequireDefault(require("classnames"));
var _utils = require("@site/utils");
var _sharedComponents = require("@site/shared-components");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
// useToggle Hook https://usehooks.com/useToggle/
// this is a hook that toggles the state between true and false
// w / o explicitly doing a setState(true) or setState(false)
// for favorites, it toggles the state: favIconFilled
const useToggle = (initialState = false) => {
  // Initialize the state
  const [state, setState] = (0, _react.useState)(initialState);

  // Define and memoize toggler function in case we pass down the component,
  // This function change the boolean value to it's opposite value
  const toggle = (0, _react.useCallback)(() => {
    setState(prevState => !prevState);
  }, []);
  return [state, toggle];
};
exports.useToggle = useToggle;
const FavoritesButton = ({
  classNames = '',
  dataEid,
  domain,
  showLabel = true,
  favoritesIcons = {
    icon: 'heart',
    filledIcon: 'heart-filled'
  }
}) => {
  const {
    AvailabilityLabel,
    Fqdn: domainName,
    Inventory
  } = domain;
  const [favoritedEntry, setFavoritedEntry] = (0, _react.useState)();
  const [favIconFilled, toggleFavIconFilled] = useToggle();
  const {
    favoritesDomainsList,
    favoritesParsedData,
    addFavoriteToUip,
    removeFavoriteFromUip
  } = (0, _sharedComponents.useUipData)();
  const {
    formatMessage
  } = (0, _reactMintl.useIntl)();
  const isInFavoritesList = favoritesDomainsList?.includes(domainName);
  const domainEntryInFavoritesList = favoritesParsedData?.find(favorite => favorite.name === domainName) || {};
  const spinDomainAvailability = ['premium', 'auction', 'registry_premium'].includes(Inventory) ? Inventory : 'available_for_registration';
  const favoriteEntryToRemove = favoritedEntry ? {
    domainName,
    dateAdded: favoritedEntry.dateAdded,
    availability: favoritedEntry.availability
  } : {
    domainName,
    dateAdded: domainEntryInFavoritesList.dateAdded,
    availability: domainEntryInFavoritesList.availability
  };
  const toggleFavorites = async ev => {
    ev.stopPropagation();
    const domainProperties = {
      domain: domain.Fqdn,
      extension: domain.Extension,
      type: domain.Inventory,
      position: domain.Index || 0,
      Ad: domain.IsAd || false
    };

    // this function adds/removes favorites
    try {
      if (favIconFilled) {
        (0, _utils.logEvent)({
          eid: `${dataEid}.save.unclick`,
          type: 'click',
          properties: {
            action: 'removeFavorite',
            ...domainProperties
          }
        });
        await removeFavoriteFromUip(favoriteEntryToRemove);
      }
      // eslint-disable-next-line no-unused-vars
    } catch (e) {
      // Should we do something with this?...
    }
    try {
      if (!favIconFilled) {
        (0, _utils.logEvent)({
          eid: `${dataEid}.save.click`,
          type: 'click',
          properties: {
            action: 'addFavorite',
            ...domainProperties
          }
        });
        const favoriteEntry = {
          domainName,
          availability: AvailabilityLabel || spinDomainAvailability,
          dateAdded: new Date().getTime()
        };
        await addFavoriteToUip(favoriteEntry);
        setFavoritedEntry(favoriteEntry);
      }
      // eslint-disable-next-line no-unused-vars
    } catch (e) {
      // TODO: do something with this error?
    }
  };
  (0, _react.useEffect)(() => {
    if (isInFavoritesList && !favIconFilled || !isInFavoritesList && favIconFilled) {
      toggleFavIconFilled();
    }
  }, [isInFavoritesList]);
  const ariaLabels = {
    ariaLabelAddToFavorites: formatMessage({
      id: 'ariaLabelAddToFavorites'
    }, {
      domainName: domainName
    }),
    ariaLabelRemoveFromFavorites: formatMessage({
      id: 'ariaLabelRemoveFromFavorites'
    }, {
      domainName: domainName
    })
  };
  const getFavoritesFilledIcon = () => {
    const favFilledIcon = favoritesIcons.filledIcon;
    return (0, _uxUtils.getIconAsync)({
      'icon': favFilledIcon,
      'iconSize': 24,
      'fill': 'teal',
      'aria-haspopup': 'true'
    });
  };
  const getFavoritesIcon = () => {
    const favIcon = favoritesIcons.icon;
    return (0, _uxUtils.getIconAsync)({
      'icon': favIcon,
      'iconSize': 24,
      'fill': 'grey',
      'aria-haspopup': 'true'
    });
  };
  return /*#__PURE__*/_react.default.createElement(_button.default, {
    "data-cy": `favorites-filled-${favIconFilled}`,
    "data-testid": `favorites-filled-${favIconFilled}`,
    onClick: toggleFavorites,
    className: (0, _classnames.default)('favorites text-black bg-transparent border-0 rounded text-primary-o', {
      'px-4 d-flex align-items-center': showLabel,
      [`${classNames}`]: true
    }),
    "aria-label": favIconFilled ? ariaLabels.ariaLabelRemoveFromFavorites : ariaLabels.ariaLabelAddToFavorites,
    icon: favIconFilled ? getFavoritesFilledIcon() : getFavoritesIcon(),
    text: showLabel && formatMessage({
      id: favIconFilled ? 'removeFavorite' : 'addFavorite'
    })
  });
};
exports.FavoritesButton = FavoritesButton;
FavoritesButton.propTypes = {
  classNames: _propTypes.default.string,
  dataEid: _propTypes.default.string,
  domain: _propTypes.default.object,
  showLabel: _propTypes.default.bool,
  favoritesIcons: _propTypes.default.shape({
    icon: _propTypes.default.string,
    filledIcon: _propTypes.default.string
  })
};